document.addEventListener('DOMContentLoaded', function () {
  const formContainer = document.querySelector('.section-newsletter .newsletter__input-group');
  if (!formContainer) return;

  const formBtn = formContainer.querySelector('.input-group-btn__required');
  const emailInput = formContainer.querySelector('input.input-group-field.newsletter__input');
  const checkboxInput = formContainer.querySelector('input.checkbox.newsletter__checkbox');
  const formMessage = formContainer.querySelector('.newsletter__message');

  let vaildEmail = false;
  let vaildCheckbox = false;

  // ===== 1. Validate Email =====
  function checkEmail() {
    const email = emailInput.value.trim();
    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if (!email || !regex.test(email)) {
      vaildEmail = false;
    } else {
      vaildEmail = true;
    }
  }

  // ===== 2. Validate Checkbox =====
  function checkCheckbox() {
    vaildCheckbox = checkboxInput.checked;
  }

  // ===== 3. Handle Button Click =====
  formBtn?.addEventListener('click', function (e) {
    if (formBtn.classList.contains('disable')) {
      e.preventDefault();

      checkEmail();
      checkCheckbox();

      formMessage.classList.remove('hidden');
      formMessage.classList.remove('email-error', 'checkbox-error', 'success');
      formContainer.classList.remove('email-error', 'checkbox-error', 'success');

      if (!vaildEmail) {
        console.log('chay vao day vaildEmail', vaildEmail);
        
        formMessage.classList.add('email-error');
        formContainer.classList.add('email-error');
        return;
      }

      if (!vaildCheckbox) {
        console.log('chay vao day vaildCheckbox', vaildCheckbox);
        formMessage.classList.add('checkbox-error');
        formContainer.classList.add('checkbox-error');
        return;
      }
    }
  });

  // ===== 4. Input Change Handler =====
  function handleInputChange() {
    checkEmail();
    checkCheckbox();

    formMessage.classList.add('hidden');
    formMessage.classList.remove('email-error', 'checkbox-error', 'success');
    formContainer.classList.remove('email-error', 'checkbox-error', 'success');

    if (vaildEmail && vaildCheckbox) {
      formBtn.classList.remove('disable');
    } else {
      formBtn.classList.add('disable');
    }
  }
  function clearCustomerPostedParam() {
    const url = new URL(window.location.href);
    if (url.searchParams.has('customer_posted')) {
      url.searchParams.delete('customer_posted');
      const newUrl = url.pathname + (url.searchParams.toString() ? '?' + url.searchParams.toString() : '');
      window.history.replaceState({}, document.title, newUrl);
    }
  }

  // ===== Events =====
  emailInput.addEventListener('input', handleInputChange);
  checkboxInput.addEventListener('change', handleInputChange);
  clearCustomerPostedParam();
});